module.exports = __webpack_public_path__ + "static/jardel-e1bf72d776ccae5fbc13a698ba8c514a.jpg";